export const environment = {
  production: true,
  urlAyudaLogin: `https://oficinavirtual.shd.gov.co/OficinaVirtual/resources/user/ayudaLogin`,
  urlAutenticar: `https://oficinavirtual.shd.gov.co/OficinaVirtual/resources/user`,
  urlAutenticarFr: `https://oficinavirtual.shd.gov.co/OficinaVirtual/resources/user/sign`,
  urlAutenticarFrIca: `https://oficinavirtual.shd.gov.co/OficinaVirtual/resources/ica/sign`,
  urlResourcesIcaInfo: `https://oficinavirtual.shd.gov.co/OficinaVirtual/resources/ica/info`,
  urlResourcesIcaDiscard: `https://oficinavirtual.shd.gov.co/OficinaVirtual/resources/ica/discard`,
  siteKeyCatchap: "6LcB9vQrAAAAADZjpqj_l6yd0jxNEPYyDJ2pfvRD",
  proxyOfinaVirtual: null,
  hostOfinaVirtual: "https://oficinavirtual.shd.gov.co",
  googleAnalyticsId:  null,
  urlPreguntasFrec: "https://www.haciendabogota.gov.co/es/preguntas",
  urlCalendario: "https://www.haciendabogota.gov.co/es/calendario-tributario",
  urlRecaudoAno: "https://www.haciendabogota.gov.co/es/noticias/consulta-nuestros-indicadores-recaudo-diciembre-25-de-2022",
  urlNoticias: "https://www.haciendabogota.gov.co/es/noticias",
  urlRegistroInfoTrib: "https://ritdqweb.shd.gov.co/validate?par1=",
  urlInstructivos: "https://back.haciendabogota.gov.co/sites/default/files/dib/impuestos/impuesto-industria-comercio/2022/paso-paso-registro-autenticacion-oficina-virt-ica-reteica-vf-dic22.pdf",
  urlPresentacionTraps: "https://oficinavirtual.shd.gov.co/Tareaps/resources/presentacion"
};
